import React, { useState, Fragment } from "react";

import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import { makeStyles } from "@material-ui/core/styles";

import KeyValue from "../display/KeyValue";

import {
  MEDIA_THUMBNAIL_URL,
  MEDIA_ORIGINAL_URL,
  PLACEHOLDER_IMG_360x360_URL,
  PLACEHOLDER_IMG_360x360_ERROR_URL,
} from "../../config";

const useStyles = makeStyles((theme) => ({
  card: {
    width: 250,
    margin: "20px",
    backgroundColor: "#212121",
  },
  img: {
    width: 250,
    height: 140,
    margin: "auto",
    objectFit: "cover",
  },
}));

const ITEM_HEIGHT = 48;

export default function MediaCard({
  media,
  index,
  totalMediaCount,
  editMediaMenuClick,
  deleteMediaMenuClick,
  swapMedia,
  isSubmitting,
  editPermission,
  deletePermission
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  function handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleMenuClose() {
    setAnchorEl(null);
  }

  function deleteMenuClick(index) {
    handleMenuClose();
    deleteMediaMenuClick(index);
  }

  function editMenuClick(index) {
    handleMenuClose();
    editMediaMenuClick(index);
  }

  function downloadMenuClick(mediaId) {
    handleMenuClose();
    window.open(`${MEDIA_ORIGINAL_URL}/${mediaId}`, "_blank");
  }

  return (
    <Card className={classes.card}>
      <CardHeader
        action={
          <Fragment>

            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleMenuClick}
              disabled={isSubmitting}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={menuOpen}
              onClose={handleMenuClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: 200,
                },
              }}
            >
              <MenuItem
                key="download"
                onClick={() => downloadMenuClick(media.mediaId)}
              >
                Download
              </MenuItem>
              {!!editPermission &&
                <MenuItem key="edit" onClick={() => editMenuClick(index)}>
                  Edit
                </MenuItem>}
              {!!deletePermission &&
                <MenuItem key="delete" onClick={() => deleteMenuClick(index)}>
                  Delete
                </MenuItem>}
            </Menu>
          </Fragment>
        }
        title={
          <Fragment>
            {editPermission &&
              <Box
                display="flex"
                flexGrow="1"
                justifyContent="space-between"
                style={{ marginTop: -8 }}
              >
                {index !== 0 ? (
                  <IconButton
                    aria-label="move-to-left"
                    onClick={() => swapMedia(index, "left")}
                    disabled={isSubmitting}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                ) : (
                  <div></div> //empty dive to align the move right button for the first card
                )}
                {index + 1 < totalMediaCount && (
                  <IconButton
                    aria-label="move-to-right"
                    onClick={() => swapMedia(index, "right")}
                    disabled={isSubmitting}
                  >
                    <ArrowForwardIcon />
                  </IconButton>
                )}
              </Box>}
          </Fragment>
        }
      />
      <CardMedia className={classes.media}>
        <img
          className={classes.img}
          alt=""
          src={
            !!media.mediaId
              ? `${MEDIA_THUMBNAIL_URL}/${media.mediaId}?width=360`
              : PLACEHOLDER_IMG_360x360_URL
          }
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = PLACEHOLDER_IMG_360x360_ERROR_URL;
          }}
        />
      </CardMedia>
      <CardContent>
        <KeyValue keyName="Short Description" value={media.caption} />
        <KeyValue
          keyName="Attribution Name"
          value={!!media.attribution && media.attribution.name}
        />
        <KeyValue
          keyName="Attribution URL"
          value={!!media.attribution && media.attribution.url}
          link={!!media.attribution && media.attribution.url}
          external
        />
        <KeyValue keyName="Description" value={media.description} />
      </CardContent>
    </Card>
  );
}
